<template>
    <v-bottom-navigation
          color="primary"
          app
        >
          <media-input-selector :buttonLabel="soundButtonLabel"></media-input-selector>
          <v-btn
            v-on:click="$emit('showDialInScreen')"
          >
            <span>Join Info</span>

            <v-icon>mdi-information-outline</v-icon>
          </v-btn>

          <v-btn v-if="activeParticipants && !sharing"
            v-on:click="$emit('startScreenSharing')"
          >
            <span>Share Screen</span>

            <v-icon>mdi-presentation-play</v-icon>
          </v-btn>

          <v-btn v-if="activeParticipants && sharing"
            v-on:click="$emit('stopScreenSharing')"
          >
            <span>Stop Sharing</span>

            <v-icon>mdi-presentation-play</v-icon>
          </v-btn>


          <v-btn v-if="activeParticipants && !myChannel.handRaised"
            v-on:click="raiseHand()"
          >
            <span>Raise Hand</span>

            <v-icon>mdi-hand-right</v-icon>
          </v-btn>

          <v-btn v-if="activeParticipants && myChannel.handRaised"
            v-on:click="lowerHand(myChannel)"
          >
            <span>Lower Hand</span>

            <v-icon>mdi-hand-left</v-icon>
          </v-btn>
    </v-bottom-navigation>
</template>
<style scoped>

.v-list-item--link::before { background-color: red; }
</style>
<script >
import ConferenceCommon from '../mixins/conferencecommon.vue';
import Common from '../mixins/common.vue';
import MediaInputSelector from '../components/media-input-selector.vue';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      soundButtonLabel: 'Sound',
    }
  },
  components: {
    'media-input-selector': MediaInputSelector,
  },
  mixins: [ConferenceCommon, Common],
  methods: {
    showDialInScreen: function() {
        this.emit('showDialInScreen');
    },
  },
  computed: {
   
  },
  async mounted() {
    
  }
})
</script>
</script>
